import React from 'react'

function Card({name,Image,onClickCard,compact,wrapperClassName}) {

    return (
        <div className={`col-lg-4 col-6 d-flex flex-column justify-content-center${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            <div className={`panel-card d-flex flex-column justify-content-center${compact ? ' panel-card-compact' : ''}`} onClick={onClickCard}>
                <img src={Image} className="card-img-top" alt="خطا"/>
                <h3>{name}</h3>
            </div>
        </div>
    );
}

export default Card;
